window.addEventListener('load', () => {
    // var navAcc = document.getElementById("accountMenu");
    // var navBtn = document.getElementById("loginClick");

    // if (navBtn) {
    //     navBtn.addEventListener("click", function() {
    //         navAcc.classList.toggle("is-Open");
    //         console.log('Account Clicked');
    //     });
    // }

    const loginClick = document.getElementById('loginClick');
    const accountMenu = document.getElementById('accountMenu');

    function toggleMenu(event) {
        event.preventDefault();
        accountMenu.style.display = accountMenu.style.display === 'none' || accountMenu.style.display === '' ? 'block' : 'none';
    }

    function hideMenu(event) {
        if (!loginClick.contains(event.target) && !accountMenu.contains(event.target)) {
            accountMenu.style.display = 'none';
        }
    }

    loginClick.addEventListener('click', toggleMenu);
    document.addEventListener('click', hideMenu);

    // document.addEventListener("click", function(event) {
    //     if (navAcc.classList.contains("is-Open") && !navAcc.contains(event.target) && !navBtn.contains(event.target)) {
    //         navAcc.classList.remove("is-Open");
    //     }
    // });
    
    let prevdeskMenu = null;

    // Select menu items with the class 'menu-item-has-megamenu > a'
    var menuItems = document.querySelectorAll('.menu-item-has-megamenu > a');

    if (menuItems.length > 0) {
        menuItems.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                const currentDeskmenu = link.closest('.menu-item-has-megamenu');

                if (!currentDeskmenu) {
                    console.error("Current menu item not found.");
                    return;
                }

                if (prevdeskMenu && prevdeskMenu !== currentDeskmenu) {
                    prevdeskMenu.classList.remove('isOpenmenu');
                }
                currentDeskmenu.classList.toggle('isOpenmenu');
                prevdeskMenu = currentDeskmenu;
            });
        });
    } else {
        console.log('No menu items with the class "menu-item-has-megamenu" found.');
    }

    // Add event listener to the window to handle clicks outside the menu
    window.addEventListener('click', function(event) {
        if (prevdeskMenu) {
            const isClickInsideMenu = prevdeskMenu.contains(event.target);
            if (!isClickInsideMenu) {
                prevdeskMenu.classList.remove('isOpenmenu');
                prevdeskMenu = null;
            }
        }
    });

    // Step 2: Use setInterval to move the .bacurr-cur-blocker element to the .navUser-section
    var intervalId = setInterval(function() {
        var navUserSection = document.querySelector('.navUser-section');
        var blockerElement = document.querySelector('.bacurr-cur-blocker');

        if (blockerElement && navUserSection) {
            navUserSection.appendChild(blockerElement);
            clearInterval(intervalId); // Stop the interval once the element is moved
        } else {}
    }, 100); // Check every second (1000 milliseconds)
});

document.addEventListener('DOMContentLoaded', function() {
    const menu = document.getElementById('full-menu-list');
    const subMenuItems = menu.querySelectorAll('.sub-menu .megaMenuBlock a');

    function handleMenuSelection(event) {
        subMenuItems.forEach(link => link.classList.remove('selected'));
        event.target.classList.add('selected');

        const allParents = document.querySelectorAll('.menu-item.menu-item-has-children');
        allParents.forEach(parent => parent.classList.remove('last-parent'));

        const parentMenu = event.target.closest('.menu-item-has-children.menu-item-has-megamenu');
        if (parentMenu) {
            parentMenu.classList.add('selected');
            parentMenu.classList.add('last-parent');
        }

        localStorage.setItem('selectedMenuItem', event.target.getAttribute('href'));
    }

    subMenuItems.forEach(link => link.addEventListener('click', handleMenuSelection));

    function initializeMenu() {
        const selectedMenuItemHref = localStorage.getItem('selectedMenuItem');
        if (selectedMenuItemHref) {
            const selectedLink = menu.querySelector(`a[href='${selectedMenuItemHref}']`);
            if (selectedLink) {
                selectedLink.classList.add('selected');
            }
        }
    }

    initializeMenu();



});